import template from './sw-cms-el-preview-acris-blog-image.html.twig';
import './sw-cms-el-preview-acris-blog-image.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-image', {
    template,

    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    }
});